import type { Component, ComponentId } from '@vgtv/api-client/lib/component';

import {
  isAssetSliderComponent,
  isCategorySliderComponent,
  isContinueWatchingComponent,
  isSeasonSliderComponent,
} from '../../../shared/helpers/componentHelpers';

export const getComponentConfig = (
  componentId: ComponentId,
  componentsConfig: Component[]
) => {
  for (const componentConfig of componentsConfig) {
    if (
      isAssetSliderComponent(componentConfig) ||
      isContinueWatchingComponent(componentConfig) ||
      isCategorySliderComponent(componentConfig)
    ) {
      if (componentConfig.id === componentId) {
        return componentConfig;
      }
    }

    if (isSeasonSliderComponent(componentConfig)) {
      const component = componentConfig.components.find(
        (componentConfig) => componentConfig.id === componentId
      );

      if (component) {
        return component;
      }
    }
  }

  return undefined;
};
